import { createSlice } from "@reduxjs/toolkit";
import { TWENTIETH_CONGRESS } from "../../utility/constants";

const initialState = {
  selectedCongress: TWENTIETH_CONGRESS,
};

export const congressSlice = createSlice({
  name: "congress",
  initialState,
  reducers: {
    setSelectedCongress: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.selectedCongress = action.payload;
    },
  },
});

export const { setSelectedCongress } = congressSlice.actions;

export default congressSlice.reducer;
